<template>
  <div>
    <a-spin :spinning="spinning">
      <a-row v-if="date > 0">
        <a-col style="padding: 10px">{{ selectMonth }}</a-col>
      </a-row>
      <div class="hgbox" v-if="date > 0">
        <table cellspacing="0" cellpadding="0">
          <thead>
            <th class="h">工人</th>
            <th class="h s">记工类型</th>
            <th class="d" v-for="n in date" :key="'head' + n">{{ n }}号</th>
          </thead>
          <tbody>
            <template v-for="(value, day) in tableData">
              <tr
                v-if="
                  !Array.isArray(value['diangong']) &&
                  typeof value['diangong'] === 'object'
                "
                :key="'body_dg' + day"
              >
                <template v-if="value.rowspan > 1">
                  <td
                    class="f"
                    :rowspan="value.rowspan"
                    v-if="value.first === 'diangong'"
                  >
                    {{ value.title }}
                  </td>
                </template>
                <td class="f" v-else>{{ value.title }}</td>
                <td class="s">点工</td>
                <td class="df" v-for="n in date" :key="'dg' + day + n">
                  <div v-if="value['diangong'].hasOwnProperty(n)">
                    {{ value["diangong"][n].work }}个工<br />{{
                      value["diangong"][n].ot_hour
                    }}小时
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  !Array.isArray(value['baogong']) &&
                  typeof value['baogong'] === 'object'
                "
                :key="'body_bg' + day"
              >
                <template v-if="value.rowspan > 1">
                  <td
                    class="f"
                    :rowspan="value.rowspan"
                    v-if="value.first === 'baogong'"
                  >
                    {{ value.title }}
                  </td>
                </template>
                <td class="f" v-else>{{ value.title }}</td>
                <td class="s">包工(按工天)</td>
                <td class="df" v-for="n in date" :key="'bg' + day + n">
                  <div v-if="value['baogong'].hasOwnProperty(n)">
                    {{ value["baogong"][n].work }}个工
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  !Array.isArray(value['amount']) &&
                  typeof value['amount'] === 'object'
                "
                :key="'body_am' + day"
              >
                <template v-if="value.rowspan > 1">
                  <td
                    class="f"
                    :rowspan="value.rowspan"
                    v-if="value.first === 'amount'"
                  >
                    {{ value.title }}
                  </td>
                </template>
                <td class="f" v-else>{{ value.title }}</td>
                <td class="s">包工(按量)</td>
                <td class="df" v-for="n in date" :key="'am' + day + n">
                  <div v-if="value['amount'].hasOwnProperty(n)">
                    <div
                      v-for="(amountInfo, index) in value['amount'][n]"
                      :key="'amount' + n + index"
                    >
                      {{ amountInfo["amount_num"]
                      }}{{ amountInfo["amount_type_title"] }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  !Array.isArray(value['jiezhi']) &&
                  typeof value['jiezhi'] === 'object'
                "
                :key="'body_jz' + day"
              >
                <template v-if="value.rowspan > 1">
                  <td
                    class="f"
                    :rowspan="value.rowspan"
                    v-if="value.first === 'jiezhi'"
                  >
                    {{ value.title }}
                  </td>
                </template>
                <td class="f" v-else>{{ value.title }}</td>
                <td class="s">借支</td>
                <td class="df jz" v-for="n in date" :key="'jz' + day + n">
                  <div v-if="value['jiezhi'].hasOwnProperty(n)">
                    {{ value["jiezhi"][n] }}元
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  !Array.isArray(value['jiesuan']) &&
                  typeof value['jiesuan'] === 'object'
                "
                :key="'body_js' + day"
              >
                <template v-if="value.rowspan > 1">
                  <td
                    class="f"
                    :rowspan="value.rowspan"
                    v-if="value.first === 'jiesuan'"
                  >
                    {{ value.title }}
                  </td>
                </template>
                <td class="f" v-else>{{ value.title }}</td>
                <td class="s">结算</td>
                <td class="df jz" v-for="n in date" :key="'js' + day + n">
                  <div v-if="value['jiesuan'].hasOwnProperty(n)">
                    {{ value["jiesuan"][n] }}元
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <a-row v-if="!spinning && date === 0" class="none">
        <a-col :span="12" :offset="6">
          <a-alert
            message="提示"
            description="暂无数据"
            type="error"
            closable
          />
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import { get } from "@/utils/request";

export default {
  name: "AttendanceTable",
  data() {
    return {
      spinning: true,
      selectMonth: "",
      date: 0,
      tableData: [],
    };
  },
  created() {
    document.title = "记工考勤表";
  },
  mounted() {
    const q = this.$route.query;

    this.selectMonth = q.year + "年" + q.month + "月分考勤表";

    const v = new Date().getTime();

    get("/attendance_table", {
      oid: q.oid,
      year: q.year,
      month: q.month,
      token: q.token,
      v,
    })
      .then((res) => {
        this.spinning = false;
        this.date = res.data.date;
        this.tableData = res.data.data;

        for (const key in this.tableData) {
          // eslint-disable-next-line no-prototype-builtins
          if (this.tableData.hasOwnProperty(key)) {
            const _tableData = this.tableData[key];
            this.tableData[key]["first"] = "";
            if (
              !Array.isArray(
                _tableData["diangong"] &&
                  typeof _tableData["diangong"] === "object"
              )
            ) {
              this.tableData[key]["first"] = "diangong";
            } else if (
              !Array.isArray(
                _tableData["baogong"] &&
                  typeof _tableData["baogong"] === "object"
              )
            ) {
              this.tableData[key]["first"] = "baogong";
            } else if (
              !Array.isArray(
                _tableData["amount"] && typeof _tableData["amount"] === "object"
              )
            ) {
              this.tableData[key]["first"] = "amount";
            } else if (
              !Array.isArray(
                _tableData["jiezhi"] && typeof _tableData["jiezhi"] === "object"
              )
            ) {
              this.tableData[key]["first"] = "jiezhi";
            } else if (
              !Array.isArray(
                _tableData["jiesuan"] &&
                  typeof _tableData["jiesuan"] === "object"
              )
            ) {
              this.tableData[key]["first"] = "jiesuan";
            }
          }
        }
      })
      .catch(() => {
        this.spinning = false;
        this.$notification.error({
          message: "通知",
          description: "暂无数据",
        });
      });
  },
};
</script>

<style scoped>
html body {
  padding: 0;
  margin: 0;
  display: flex;
  width: 100vw;
  height: 100vh;
}

.hgbox::-webkit-scrollbar {
  display: none;
}

.hgbox {
  overflow: auto;
  flex: 1;
  border: 1px solid gray;
  border-bottom: 0;
  border-right: 0;
}

td,
th {
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  height: 40px;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
}

th {
  background-color: #f9f9f9;
}

table {
  border-collapse: separate;
  table-layout: fixed;
  width: 100%;
}

.f,
.h {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: #f5f5f5;
  width: 80px;
}

.s {
  position: sticky;
  left: 80px;
  z-index: 2;
  background-color: #f5f5f5;
  width: 80px;
}

thead tr th {
  position: sticky;
  top: 0;
}

.h {
  z-index: 3;
  background-color: #f9f9f9;
}

.d {
  width: 60px;
}

.df {
  font-size: 12px;
}

.jz {
  color: green;
}
.none {
  margin-top: 100px;
}
</style>